
import { Component, Vue } from 'vue-property-decorator'
import { CommonService, MediaService } from '@/services'
// import { pick } from 'lodash'
import pick from 'lodash/pick'
import FullLoading from '@/components/full_loading/index.vue'
import CreateDetailLayout from '@/layout/edit_layout.vue'
import RowWrap from '@/components/detail/row_wrap/index.vue'
import RowItem from '@/components/detail/row_item/index.vue'

const typeObj = { url: 1, xpath: 2, api: 3 }
const configType = [
    { value: typeObj.url, name: '只提供网址' },
    { value: typeObj.xpath, name: 'xpath' },
    { value: typeObj.api, name: 'api' }
]
const paramsMap = {
    public: ['medium_id', 'type', 'task_name', 'url', 'remarks'],
    [typeObj.url]: [],
    [typeObj.xpath]: ['article_xpath', 'title_xpath', 'publishedat_xpath', 'coverimg_xpath', 'content_xpath', 'originurl_xpath','reporter_xpath', 'source_xpath','formdata'],
    [typeObj.api]: ['content_xpath', 'lists_name', 'title_name', 'originurl_name', 'publishedat_name', 'coverimg_name', 'reporter_xpath', 'source_xpath','formdata']
}

@Component({
    name: 'createMediaSplider',
    components: {
        FullLoading,
        CreateDetailLayout,
        RowWrap,
        RowItem
    }
})
export default class extends Vue {
    private spliderId = ''
    private isLoading = true
    private updateLoading = false
    private mediaQuery = ''
    private config = {
        medium_id: '',
        task_name: '',
        type: 1,
        url: '',
        originurl_xpath: '',
        article_xpath: '',
        title_xpath: '',
        publishedat_xpath: '',
        coverimg_xpath: '',
        content_xpath: '',
        reporter_xpath: '',
        source_xpath: '',
        formdata: '',
        title_name: '',
        lists_name: '',
        originurl_name: '',
        publishedat_name: '',
        coverimg_name: '',
        remarks: ''
    }
    private otherInfo = {
        id: '',
        is_check: { id: '' },
        is_pass: { id: '' }
    }
    private prevPassStatus = ''
    private typeObj = typeObj
    private configType = configType

    created() {
        this.spliderId = this.$route.params.id
        this.$title('爬虫定制详情 - 庖丁')
    }
    async mounted() {
        this.isLoading = true
        try {
            await this.getSpliderDetail()
        } catch (error) {
            this.$message({ type: 'error', message: '加载失败：' + (error as Error).message })
        } finally {
            this.isLoading = false
        }

    }
    // 获取爬虫配置详情
    async getSpliderDetail() {
        const result = await CommonService.getSpiderConfigDetail({ id: this.spliderId })
        if (result.status === 200) {
            (this.config as any) = {
                ...pick(result.data, Object.keys(this.config)),
                url: result.data.url.join(','),
                type: result.data.type.id,
                medium_id: result.data.medium.id
            }
            this.otherInfo = pick(result.data, [
                'id',
                'created_at', 
                'updated_at', 
                'news_count', 
                'is_check', 
                'is_pass'
            ])
            this.prevPassStatus = result.data.is_pass.id
            this.mediaQuery = result.data.medium.name
            this.$title(`${result.data.task_name} | 爬虫定制详情 - 庖丁`)
        }
    }
    // 判断是否显示
    isShow(type: number | number[]) {
        if (Array.isArray(type)) {
            return type.includes(this.config.type)
        }
        return type === this.config.type
    }
    // 搜索媒体
    async onSearchMedia(query: string, callback: any) {
        if (!query) return callback([])
        const result = await MediaService.searchMedia({ value: query })
        if (result.status === 200) {
            return callback(result.data)
        }
        return callback([])
    }
    // 选择媒体
    onSelectMedia(val: any) {
        this.config.medium_id = val.id
    }
    // 清空媒体
    onMediaClear() {
        this.config.medium_id = ''
    }
    // 修改配置
    onUpdateConfig() {
        if (!this.config.medium_id) {
            return this.$mwarning('请先选择媒体')
        }
        this.$confirm('是否确认修改该爬虫配置?', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            this.updateLoading = true
            const params = {
                ...pick(this.config, paramsMap.public),
                ...pick(this.config, paramsMap[this.config.type]),
                is_pass: this.otherInfo.is_pass.id,
                id: this.otherInfo.id,
                url: this.config.url.split(',').map(n => n.replace('\n', '').trim())
            }
            const result = await CommonService.updateSpiderConfig(params)
            this.updateLoading = false
            if (result.status === 200) {
                this.prevPassStatus = this.otherInfo.is_pass.id
                return this.$msuccess('修改成功')
            }
            this.$merror(result.message || '发生错误, 请稍后再试')
        }).catch(() => {
            // type url     ☑️
            // type xpath   ☑️
            // type api     ☑️       
        })
    }
}
